import { Component, Input } from '@angular/core';
import {SubscriptionModel} from "@white-label/components/page-builder/models/subscription.model";
import {BackTranslatePipe} from "@cybfed/shared/pipes/back-translate.pipe";
import {JsonPipe, NgForOf, NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
@Component({
    selector: 'app-pricing-component',
    standalone: true,
    imports: [
        BackTranslatePipe,
        NgForOf,
        NgIf,
        TranslateModule,
        JsonPipe
    ],
    providers: [
    ],
    templateUrl: './pricing.component.html'
})
export class PricingComponent {
    @Input() componentModel: SubscriptionModel = new SubscriptionModel();
    constructor(public mainStore: MainStoreService) {
    }
}
